/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { NgModule } from '@angular/core';
import { CommonModule }   from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// QRCode
import { NgxQRCodeModule } from 'ngx-qrcode2';

// DropZone
import { DropzoneModule, DROPZONE_CONFIG, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
    // Change this to your upload POST address:
    url: 'https://httpbin.org/post',
    maxFilesize: 50,
    acceptedFiles: '.jpg, .txt, .pdf, .xls, .xlsx, .doc, .docx',
    addRemoveLinks: true
};

import { IcemedxLibComponent } from './icemedx-lib.component';
import { IceMaterialModule } from '../modules/ice-material/ice-material.module';

// Panel
import { IcepanelService } from '../components/icepanel/icepanel.service'
import { IcesectionComponent } from '../components/icepanel/icesection.component';
import { IcepanelComponent } from '../components/icepanel/icepanel.component';
import { IcelogpanelComponent } from '../components/icepanel/icelogpanel.component';
import { IcepanelContainerComponent } from '../components/icepanel/icepanelcontainer.component';
import { IcecontrolComponent, IceheadercontrolComponent } from '../components/icepanel/icecontrol.component';

// Control 
import { IcebuttonComponent, IcepanelbuttonComponent } from '../components/icebutton/icebutton.component';
import { IceinputComponent } from '../components/iceinput/iceinput.component';
import { IceselectComponent } from '../components/iceselect/iceselect.component';
import { IcebuttongroupComponent } from '../components/icebuttongroup/icebuttongroup.component';
import { IcedatepickerComponent } from '../components/icedatepicker/icedatepicker.component';
import { IcedragdropComponent } from '../components/icedragdrop/icedragdrop.component';
import { IcematgridComponent } from '../components/icepanel/icematgrid.component';
import { IceMattableResponsiveComponent } from '../components/icepanel/icemattableresponsive.component';
import { IceMattableResponsiveMobileEditComponent } from '../components/icepanel/icemattableresponsivemobileedit.component';
import { IceMattableResponsiveDesktopEditComponent } from '../components/icepanel/icemattableresponsivedesktopedit.component';
import { IcePaginationComponent } from '../components/icepagination/icepagination.component';
import { IceqrbarcodeComponent } from '../components/ice-qrbarcode/iceqrbarcode.component';
import { IcecontrolSettings } from '../components/models/icesettings';
import { IceautocompleteComponent } from '../components/iceautocomplete/iceautocomplete.component';
import { IcebottomSheetComponent } from '../components/icebottomsheet/icebottomsheet.component'
import { IceloaderComponent } from '../components/iceloader/iceloader.component';
import { IcesplitbuttonComponent } from '../components/icesplitbutton/icesplitbutton.component';
import { IcesingleUploadComponent } from '../components/icesingleupload/icesingleupload.component';

// Common
import { Iceutility } from '../services/iceutility';

import { IceNavService } from '../components/ice-nav/ice-nav.service';
import { IceNavComponent } from '../components/ice-nav/ice-nav.component';

import { LoginService } from '../login/login.service';
import { DomainService } from '../services/domain/domain.service';
import { XmlparseService } from '../services/xml/xmlparse.service';
import { LoginGuard } from 'projects/icemedx-lib/src/login/login.guard';
import { LoginResolver } from '../login/login.resolver';
import { LoginHttpInterceptor } from '../login/loginhttp-interceptor';

import { LogincallbackComponent } from '../login/logincallback/logincallback.component';
import { LoginflowComponent } from '../login/loginflow/loginflow.component';
import { MedicalcodesService } from '../services/medicalcodes/medicalcodes.service';
import { MembersComponent } from './members/members.component';
import { InviteComponent } from './invite/invite.component';
import { IceexpansionpanelComponent } from '../../src/components/iceexpansionpanel/iceexpansionpanel.component';
import { IceradiobuttonComponent } from '../../src/components/iceradiobutton/iceradiobutton.component';
import { IcelabelComponent } from '../components/icelabel/icelabel.component';
import { IcetextareaComponent } from '../components/icetextarea/icetextarea.component';
import { IcecheckboxComponent } from '../components/icecheckbox/icecheckbox.component';
import { IcerecaptchaComponent } from '../components/icerecaptcha/icerecaptcha.component';
import { IcebreadcrumbsComponent } from '../components/icebreadcrumbs/icebreadcrumbs.component';
import { IcegooglechartComponent } from '../components/icegooglechart/icegooglechart.component';
import { IcedivComponent } from '../components/icediv/icediv.component';
import { IceslidetoggleComponent } from '../components/iceslidetoggle/iceslidetoggle.component';
import { IcesubscriptionpaymentComponent } from '../components/icesubscriptionpayment/icesubscriptionpayment.component';
import { IcepaymentreceiptComponent } from '../components/icepaymentreceipt/icepaymentreceipt.component';
import { AccountingService } from '../services/accounting/accounting.service';
import { SignerService } from '../login/signer.service';
import { SignerResolver } from '../login/signer.resolver';
import { IceMultimediaComponent } from '../components/icemultimedia/iceMultimedia.component';
import { IcetabComponent } from '../components/icetab/icetab.component';
import { SignercallbackComponent } from '../login/logincallback/signercallback.component';
import { IcepaypalsimplesubscribeComponent } from '../components/icepaypalsimplesubscribe/icepaypalsimplesubscribe.component';
import { IcepanelDialog } from '../components/icepaneldialog/icepaneldialog';
import { IcematListComponent } from '../components/icematlist/icematlist.component';

@NgModule({
    imports: [
      CommonModule,
      DropzoneModule,
      NgxQRCodeModule,
      IceMaterialModule
    ],
    declarations: [
      IcemedxLibComponent,

      /* Panel */
      IcecontrolComponent,
      IceheadercontrolComponent,
      IcesectionComponent,
      IcepanelComponent,
      IcepanelContainerComponent,
      IcelogpanelComponent,

      /* Controls */
      IcebuttonComponent,
      IcepanelbuttonComponent,
      IceinputComponent,
      IceselectComponent,
      IcebuttongroupComponent,
      IcedatepickerComponent,
      IcedragdropComponent,
      IcematgridComponent,
      IceMattableResponsiveComponent,
      IceMattableResponsiveMobileEditComponent,
      IceMattableResponsiveDesktopEditComponent,
      IcePaginationComponent,
      IceqrbarcodeComponent,
      IceautocompleteComponent,
      IceloaderComponent,
      IcesplitbuttonComponent,
      IcesingleUploadComponent,
      /* Login */
      LogincallbackComponent,
      SignercallbackComponent,
      LoginflowComponent,

      IceNavComponent,

      MembersComponent,

      InviteComponent,

      IceexpansionpanelComponent,

      IceradiobuttonComponent,

      IcelabelComponent,
      IcetextareaComponent,
      IcecheckboxComponent,
      IcerecaptchaComponent,
      IcebreadcrumbsComponent,
      IcegooglechartComponent,
      IcebottomSheetComponent,
      IcedivComponent,
      IceslidetoggleComponent,
      IcesubscriptionpaymentComponent,
      IcepaymentreceiptComponent,
      IceMultimediaComponent,
      IcetabComponent,
      IcepaypalsimplesubscribeComponent,
      IcepanelDialog,
      IcematListComponent
    ],
    exports: [
      IcemedxLibComponent,

      /* Panel */
      IcecontrolComponent,
      IceheadercontrolComponent,
      IcesectionComponent,
      IcepanelComponent,
      IcepanelContainerComponent,
      IcelogpanelComponent,

      /* Controls */
      IcebuttonComponent,
      IceinputComponent,
      IceselectComponent,
      IcebuttongroupComponent,
      IcedatepickerComponent,
      IcedragdropComponent,
      IcematgridComponent,
      IceMattableResponsiveComponent,
      IceMattableResponsiveMobileEditComponent,
      IceMattableResponsiveDesktopEditComponent,
      IcePaginationComponent,
      IceqrbarcodeComponent,
      IcebreadcrumbsComponent,
      IcegooglechartComponent,
      IcebottomSheetComponent,
      IceautocompleteComponent,
      IceloaderComponent,
      IcetextareaComponent,
      IcesplitbuttonComponent,
      IceslidetoggleComponent,
      IcelabelComponent,
      IcesingleUploadComponent,
      IcecheckboxComponent,
      IcesubscriptionpaymentComponent,
      IceMultimediaComponent,
      IcetabComponent,
      IcepaypalsimplesubscribeComponent,
      IcepanelDialog,
      IcematListComponent,

      LogincallbackComponent,
      SignercallbackComponent,
      LoginflowComponent,

      IceNavComponent,

      MembersComponent,

      InviteComponent,

      IceMaterialModule
    ],
    providers: [
      IceNavService,
      LoginService,
      LoginGuard,
      LoginResolver,
      LoginHttpInterceptor,
      SignerService,
      SignerResolver,
      DomainService,
      XmlparseService,
      { provide: DROPZONE_CONFIG, useValue: DEFAULT_DROPZONE_CONFIG },
      { provide: HTTP_INTERCEPTORS, useClass: LoginHttpInterceptor, multi: true },
      IcepanelService,
      XmlparseService,
      MedicalcodesService,
      AccountingService,
    ],
  entryComponents: [
    IcebottomSheetComponent, IcepanelDialog
  ]
})
export class IcemedxLibModule { }
